import { useHistory } from 'react-router-dom';
import { Icon } from 'src/common/components/icon';

export const CreateSpace = () => {
  const history = useHistory();

  return (
    <div className="mt-auto">
      <div className="border-y border-grey6 p-4 text-grey3 text-t4">
        当前为「外部协作者身份」，仅可参与指定页面协作，不支持建立独立页面，如需参与更多协作，可联系空间管理员将你升级为「空间成员」
      </div>
      <div
        onClick={() => {
          history.push('/create');
        }}
        className="flex items-center p-4 animate-hover text-grey3"
      >
        <Icon size="small" name="IcAddSmallBold" />
        <div className="text-t2 ml-3">创建我的空间</div>
      </div>
    </div>
  );
};
